export const MAPPE_PREFIX = "mappe";
export const STUDIEPROGRAM_PREFIX = "studieprogram";
export const PENSUM_PREFIX = "pensum";
export const ARTIKKEL_PREFIX = "artikkel";
export const OPPGAVE_PREFIX = "oppgave";
export const KURSSLOEYFE_PREFIX = "kurs";
export const SELVTEST_PREFIX = "selvtest";
export const PROFILE_PREFIX = "profil";
export const SIMULERING_PREFIX = "simulering";

export const ADMIN_PREFIX = "admin";

export const urls = {
  frontPage: "/",
  profile: "/profil",
  termsOfUse: "/vilkar",

  myStudies: "/pensum",
  simulation: "/simulering",
  library: "/bibliotek",
  feedback: "/feedback",
  teacherFeedback: "/teacher-feedback",
  teacherQuestions: "/teacher-questions",
  questions: "/questions",
  profilePrivacy: `/${PROFILE_PREFIX}/personvern`,
  profileStudies: `/${PROFILE_PREFIX}/studie`,

  graphiql: "/graphiql",
  sentryExample: "/sentry-example",
  cognitoCallback: "/cognito-callback",
  devLoadingExample: "/dev/loading-example",
  devErrorExample: "/dev/error-example",

  admin: `/${ADMIN_PREFIX}`,
  studyProgrammeAdminOverview: `/${ADMIN_PREFIX}/${STUDIEPROGRAM_PREFIX}`,
  simulationAdminOverview: `/${ADMIN_PREFIX}/${SIMULERING_PREFIX}`,

  folder: (folderId: string): string => `/${MAPPE_PREFIX}/${folderId}`,
  folderDescription: (folderId: string): string =>
    `/${MAPPE_PREFIX}/${folderId}/beskrivelse`,
  folderAdmin: (folderId: string): string =>
    `/${ADMIN_PREFIX}/${MAPPE_PREFIX}/${folderId}`,
  folderAdminEdit: (folderId: string): string =>
    `/${ADMIN_PREFIX}/${MAPPE_PREFIX}/${folderId}/edit`,

  exam: (examId: string): string => `/${PENSUM_PREFIX}/${examId}`,
  examDescription: (examId: string): string =>
    `/${PENSUM_PREFIX}/${examId}/beskrivelse`,
  examAdmin: (examId: string): string =>
    `/${ADMIN_PREFIX}/${PENSUM_PREFIX}/${examId}`,
  examAdminEdit: (examId: string): string =>
    `/${ADMIN_PREFIX}/${PENSUM_PREFIX}/${examId}/edit`,

  studyProgramme: (studyProgrammeId: string): string =>
    `/${STUDIEPROGRAM_PREFIX}/${studyProgrammeId}`,
  studyProgrammeDescription: (studyProgrammeId: string): string =>
    `/${STUDIEPROGRAM_PREFIX}/${studyProgrammeId}/beskrivelse`,
  studyProgrammeAdmin: (studyProgrammeId: string): string =>
    `/${ADMIN_PREFIX}/${STUDIEPROGRAM_PREFIX}/${studyProgrammeId}`,
  studyProgrammeAdminEdit: (studyProgrammeId: string): string =>
    `/${ADMIN_PREFIX}/${STUDIEPROGRAM_PREFIX}/${studyProgrammeId}/edit`,
  studyProgrammeAdminExams: (studyProgrammeId: string): string =>
    `/${ADMIN_PREFIX}/${STUDIEPROGRAM_PREFIX}/${studyProgrammeId}/${PENSUM_PREFIX}`,

  kurssloeyfe: (id: string): string => `/${KURSSLOEYFE_PREFIX}/${id}`,
  kurssloeyfeArticle: (id: string, kurssloeyfeId: string): string =>
    `/${KURSSLOEYFE_PREFIX}/${kurssloeyfeId}${urls.article(id)}`,
  kurssloeyfeQuestion: (id: string, kurssloeyfeId: string): string =>
    `/${KURSSLOEYFE_PREFIX}/${kurssloeyfeId}${urls.question(id)}`,
  kurssloeyfeAdmin: (id: string): string =>
    `/${ADMIN_PREFIX}/${KURSSLOEYFE_PREFIX}/${id}`,
  kurssloeyfeAdminEdit: (id: string): string =>
    `/${ADMIN_PREFIX}/${KURSSLOEYFE_PREFIX}/${id}/edit`,

  article: (id: string): string => `/${ARTIKKEL_PREFIX}/${id}`,
  articleAdmin: (id: string): string =>
    `/${ADMIN_PREFIX}/${ARTIKKEL_PREFIX}/${id}`,
  articleAdminEdit: (id: string): string =>
    `/${ADMIN_PREFIX}/${ARTIKKEL_PREFIX}/${id}/edit`,

  question: (id: string): string => `/${OPPGAVE_PREFIX}/${id}`,
  assignmentAdmin: (id: string): string =>
    `/${ADMIN_PREFIX}/${OPPGAVE_PREFIX}/${id}`,
  assignmentAdminEdit: (id: string): string =>
    `/${ADMIN_PREFIX}/${OPPGAVE_PREFIX}/${id}/edit`,

  selfAssessment: (id: string): string => `/${SELVTEST_PREFIX}/${id}`,
  selfAssessmentArticle: (
    id: string,
    selfAssessmentId: string,
    //p0: any,
    //p1: string,
  ): string => `/${SELVTEST_PREFIX}/${selfAssessmentId}/artikkel/${id}`,
  selfAssessmentQuestion: (id: string, selfAssessmentId: string): string =>
    `/${SELVTEST_PREFIX}/${selfAssessmentId}/oppgave/${id}`,

  simulationCase: (id: string): string => `/${SIMULERING_PREFIX}/${id}`,
  simulationCaseAdmin: (id: string): string =>
    `/${ADMIN_PREFIX}/${SIMULERING_PREFIX}/${id}`,

  simulationCaseGenerate: (id: string): string =>
    `/auto/${SIMULERING_PREFIX}/${id}`,

  simulationDiagnosisAdmin: (id: string): string =>
    `/${ADMIN_PREFIX}/${SIMULERING_PREFIX}/${id}/diagnostisering/edit`,
};
